import { connect } from 'react-redux';
import AccountSelection from '../../components/shared_policies/AccountSelection';

import { getActiveAvailableEditAccounts } from '../../selectors/account';
import { onChangeEditAccountSelection } from '../../actions/shared_policies';

const mapStateToProps = (state, ownProps) => {
  let accounts = [];
  let activeAccounts = getActiveAvailableEditAccounts(state);

  for (let i = 0; i < activeAccounts.length; i++) {
    accounts.push({
      type: 'smb_account',
      label: activeAccounts[i]['name'],
      value: activeAccounts[i]['account_id'],
    });
  }

  return {
    inputValue: state.shared_policies.editFields.updatedAccountSelections,
    options: accounts,
  };
};

const mapDispatchToProps = dispatch => ({
  onChange: value => {
    dispatch(onChangeEditAccountSelection(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountSelection);
